"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./TabsContainer.scss");
var key_press_1 = require("../../../utils/key-press");
var TabsContainer = /** @class */ (function (_super) {
    __extends(TabsContainer, _super);
    function TabsContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            _this.mounted = true;
            // sets variable margin between each tab item and also original location of black button overlay
            _this.calcMargin(function () {
                return _this.moveTab(_this.props.defaultIndex ? _this.props.defaultIndex : 0, true, false, function () { return _this.setState({ transitionOn: true }); }, true);
            }, true);
            _this.calcMargin(function () {
                return _this.moveTab(_this.props.defaultIndex ? _this.props.defaultIndex : 0, true, false, function () {
                    return _this.setState({ transitionOn: true });
                });
            });
            // listens for screen size changes
            window.addEventListener("resize", _this.onScreenResize);
        };
        _this.componentWillUnmount = function () {
            window.removeEventListener("resize", _this.onScreenResize);
            _this.mounted = false;
        };
        _this.calcMargin = function (cb, initial) {
            var data = _this.props.data;
            var fullWidthTab = _this.state.fullWidthTab;
            var viewportWidth = _this.tabsOuterContRef ? _this.tabsOuterContRef.offsetWidth : 0;
            var offset = viewportWidth > 1024 ? 50.75 : viewportWidth > 767 ? 34.75 : 18.75;
            var tabContWidth = fullWidthTab
                ? viewportWidth
                : _this.tabsContRef
                    ? _this.tabsContRef.offsetWidth
                    : 0;
            var sum = (viewportWidth >= 768 ? 36 : 32) + _this.tabsRef[0].offsetWidth + offset;
            var stoppingIndex;
            // calculates if tabs fits using mininum space
            for (var i = 1; i < data.length; i++) {
                var temp = sum +
                    4 +
                    _this.tabsRef[i].offsetWidth / 2 -
                    (viewportWidth >= 768 &&
                        !(viewportWidth <= 666 || window.matchMedia("(orientation: portrait)").matches)
                        ? 32
                        : 24);
                if (temp > tabContWidth && stoppingIndex === undefined) {
                    stoppingIndex = i - 1;
                }
                else {
                    sum += 4 + _this.tabsRef[i].offsetWidth + offset;
                }
            }
            // if the width of the tab container is greater than the sum of tabs and spaces
            if (tabContWidth > sum) {
                // use the real offset
                var realOffset = viewportWidth > 1024 ? 50 : viewportWidth > 767 ? 34 : 18;
                if (initial) {
                    _this.tabMarR = realOffset + "px";
                    _this.fullWidthTab = false;
                    if (cb) {
                        cb();
                    }
                }
                else {
                    _this.setState({
                        tabMarR: realOffset + "px",
                        fullWidthTab: false,
                    }, cb ? cb : function () { return null; });
                }
            }
            else {
                // cases for last index as stopping index
                if (!stoppingIndex) {
                    stoppingIndex = data.length - 1;
                }
                // calculates what padding should be to make it show half of a tab with variable space
                sum = viewportWidth > 767 ? 36 : 24;
                for (var i = 0; i <= stoppingIndex; i++) {
                    if (i === stoppingIndex) {
                        sum += 4 + _this.tabsRef[i].offsetWidth / 2;
                    }
                    else {
                        sum += 4 + _this.tabsRef[i].offsetWidth;
                    }
                }
                var spaceLeft = tabContWidth - sum;
                var realSpace = spaceLeft / stoppingIndex;
                var tabMarR = realSpace + "px";
                if (initial) {
                    _this.tabMarR = tabMarR;
                    _this.fullWidthTab = true;
                    if (cb) {
                        cb();
                    }
                }
                else {
                    _this.setState({
                        tabMarR: tabMarR,
                        fullWidthTab: true,
                    }, cb ? cb : function () { return null; });
                }
            }
        };
        _this.moveTab = function (index, hideFocus, focusTab, cb, initial) {
            if (hideFocus === void 0) { hideFocus = true; }
            if (focusTab === void 0) { focusTab = false; }
            if (initial) {
                _this.moveTabInner(index, hideFocus, focusTab, cb, initial);
            }
            else {
                // setTimeout fixes not moving tab in inspect mode bug
                setTimeout(function () {
                    _this.moveTabInner(index, hideFocus, focusTab, cb, initial);
                }, 1);
            }
        };
        _this.moveTabInner = function (index, hideFocus, focusTab, cb, initial) {
            if (hideFocus === void 0) { hideFocus = true; }
            if (focusTab === void 0) { focusTab = false; }
            // moves the black button overlay
            var _a = _this.props, alignment = _a.alignment, isTransparent = _a.isTransparent;
            var _b = _this.state, fullWidthTab = _b.fullWidthTab, initializedA = _b.initializedA, tabMarR = _b.tabMarR;
            var tabMarRVal = parseFloat((initializedA ? tabMarR : _this.tabMarR).substring(0, (initializedA ? tabMarR : _this.tabMarR).length - 2));
            var viewportWidth = window.innerWidth;
            var offset = viewportWidth >= 768 ? 22 : 6;
            var left = 0;
            var width = 0;
            for (var i = 0; i <= index; i++) {
                if (_this.tabsRef[i] !== null) {
                    if (i === index) {
                        width = _this.tabsRef[i].offsetWidth + offset;
                    }
                }
            }
            left = viewportWidth > 767 ? _this.tabsRef[index].offsetLeft - 10 : _this.tabsRef[index].offsetLeft - 2;
            if (focusTab) {
                _this.tabsRef[index].focus();
            }
            if (_this.mounted) {
                if (initial) {
                    _this.blackTabStyleLeft = left + "px";
                    _this.blackTabStyleWidth = width + "px";
                    _this.currentIndex = index;
                    _this.prevIndex = 0;
                    _this.setState({ visible: true });
                }
                else {
                    _this.setState(function (_a) {
                        var currentIndex = _a.currentIndex;
                        return ({
                            blackTabStyle: {
                                left: left + "px",
                                width: width + "px",
                            },
                            currentIndex: index,
                            initializedA: true,
                            prevIndex: currentIndex,
                        });
                    }, 
                    // scrolls after black button overlay moves
                    function () {
                        setTimeout(function () {
                            if (_this.mounted) {
                                _this.setState({ initializedB: true, transitionOn: false, hideFocus: hideFocus }, function () {
                                    _this.scrollToRightPos(index);
                                    if (cb) {
                                        cb();
                                    }
                                });
                            }
                        }, 500);
                        clearTimeout(_this.resizeTimeout);
                        _this.resizeTimeout = window.setTimeout(function () {
                            _this.setState(function (_a) {
                                var currentIndex = _a.currentIndex;
                                return ({
                                    blackTabStyle: {
                                        left: left + "px",
                                        width: width + "px",
                                    },
                                    currentIndex: index,
                                    initializedA: true,
                                    prevIndex: currentIndex,
                                });
                            });
                        }, 501);
                    });
                }
            }
        };
        _this.onKeyUp = function (e) {
            var data = _this.props.data;
            var currentTarget = e.currentTarget;
            var id = currentTarget.id;
            var el = document.getElementById(id);
            var value = el.getAttribute("index");
            var valueInt = parseInt(value, 10);
            if (key_press_1.KeyPress.leftArrowIsPressed(e)) {
                _this.tabsRef[valueInt].blur();
                if (valueInt !== 0) {
                    _this.tabsRef[valueInt - 1].focus();
                    _this.setState({ transitionOn: true, hideFocus: true }, function () {
                        if (_this.props.onSelect) {
                            _this.props.onSelect(valueInt);
                        }
                        _this.moveTab(valueInt - 1, false, true);
                    });
                }
                else {
                    _this.tabsRef[data.length - 1].focus();
                    _this.setState({ transitionOn: true, hideFocus: true }, function () {
                        if (_this.props.onSelect) {
                            _this.props.onSelect(valueInt);
                        }
                        _this.moveTab(data.length - 1, false, true);
                    });
                }
            }
            else if (key_press_1.KeyPress.rightArrowIsPressed(e)) {
                _this.tabsRef[valueInt].blur();
                if (valueInt !== data.length - 1) {
                    _this.tabsRef[valueInt + 1].focus();
                    _this.setState({ transitionOn: true, hideFocus: true }, function () {
                        if (_this.props.onSelect) {
                            _this.props.onSelect(valueInt);
                        }
                        _this.moveTab(valueInt + 1, false, true);
                    });
                }
                else {
                    _this.tabsRef[0].focus();
                    _this.setState({ transitionOn: true, hideFocus: true }, function () {
                        if (_this.props.onSelect) {
                            _this.props.onSelect(valueInt);
                        }
                        _this.moveTab(0, false, true);
                    });
                }
            }
            else if (key_press_1.KeyPress.tabIsPressed(e)) {
                _this.setState({ hideFocus: false });
            }
        };
        _this.onMouseDown = function (e) {
            if (e.button === 0) {
                if (_this.onClickTimeout) {
                    clearTimeout(_this.onClickTimeout);
                }
                var id = e.currentTarget.id;
                var el = document.getElementById(id);
                var value_1 = el.getAttribute("index");
                _this.onClickTimeout = window.setTimeout(function () {
                    var valueInt = parseInt(value_1, 10);
                    if (_this.mounted) {
                        _this.setState({ hideFocus: true, transitionOn: true }, function () {
                            return _this.moveTab(valueInt, true, true);
                        });
                        if (_this.props.onSelect) {
                            _this.props.onSelect(valueInt);
                        }
                    }
                }, 150);
            }
        };
        _this.onScreenResize = function () {
            // re-calculates margin every time screen is resized
            var _a = _this.state, currentIndex = _a.currentIndex, hideFocus = _a.hideFocus;
            _this.calcMargin(function () { return _this.moveTab(currentIndex, hideFocus); });
        };
        _this.scrollToRightPos = function (index) {
            // adjusts horizontal scroll position to fit black button overlay within view
            var _a = _this.props, data = _a.data, name = _a.name;
            var scrollEl = document.getElementById("tab_scroll_" + name);
            if (scrollEl) {
                var scrollLeft = scrollEl.scrollLeft;
                var blackTabStyle = _this.state.blackTabStyle;
                var left = blackTabStyle.left, width = blackTabStyle.width;
                var leftNum = parseFloat(left.substring(0, left.length - 2));
                var widthNum = parseFloat(width.substring(0, left.length - 2));
                var right = leftNum + widthNum;
                var scrollContWidth = _this.tabsScrollRef ? _this.tabsScrollRef.offsetWidth : 0;
                if (index === 0) {
                    scrollEl.scrollLeft = 0;
                }
                else if (index === data.length) {
                    scrollEl.scrollLeft = scrollContWidth;
                }
                else if (leftNum < scrollLeft) {
                    scrollEl.scrollLeft = leftNum - 16;
                }
                else if (right > scrollLeft + scrollContWidth) {
                    scrollEl.scrollLeft =
                        parseFloat((leftNum - scrollContWidth + widthNum).toString()) + 16;
                }
            }
        };
        _this.render = function () {
            var _a = _this.props, _b = _a.alignment, alignment = _b === void 0 ? "center" : _b, _c = _a.className, className = _c === void 0 ? "" : _c, _d = _a.contentClassName, contentClassName = _d === void 0 ? "" : _d, _e = _a.bgType, bgType = _e === void 0 ? "dark" : _e, _f = _a.bottomClassName, bottomClassName = _f === void 0 ? "" : _f, data = _a.data, _g = _a.isTransparent, isTransparent = _g === void 0 ? false : _g, name = _a.name, _h = _a.tabGridCol, tabGridCol = _h === void 0 ? 12 : _h, testId = _a.testId, _j = _a.topClassName, topClassName = _j === void 0 ? "" : _j, tabIndex = _a.tabIndex;
            var _k = _this.state, blackTabStyle = _k.blackTabStyle, currentIndex = _k.currentIndex, hideFocus = _k.hideFocus, fullWidthTab = _k.fullWidthTab, initializedA = _k.initializedA, initializedB = _k.initializedB, prevIndex = _k.prevIndex, tabMarR = _k.tabMarR, transitionOn = _k.transitionOn, visible = _k.visible;
            var ariaOwns = "";
            for (var i = 0; i < data.length; i++) {
                ariaOwns += "" + (i === 0 ? "" : " ") + name + "-" + i;
            }
            console.log("tabIndex: ", tabIndex);
            return (React.createElement("div", { "data-testid": testId, style: { visibility: visible ? "visible" : "hidden" } },
                React.createElement("div", { className: styles.tabsContainer + " " + className },
                    React.createElement("div", { className: "row " + styles.tabsShowTopPadding + (topClassName ? " " + topClassName : ""), ref: function (ref) { return (_this.tabsOuterContRef = ref); } },
                        React.createElement("div", { className: (isTransparent
                                ? ""
                                : bgType === "light" &&
                                    (initializedA ? fullWidthTab : _this.fullWidthTab)
                                    ? "bg-ui-white "
                                    : bgType === "dark" &&
                                        (initializedA ? fullWidthTab : _this.fullWidthTab)
                                        ? "bg-black "
                                        : bgType === "grey" &&
                                            (initializedA ? fullWidthTab : _this.fullWidthTab)
                                            ? "bg-ui-background-gray "
                                            : "") + "grid-col-" + (alignment === "left" ? 12 : tabGridCol) + " grid-col-12-md grid-col-12-sm mar-none-md mar-none-sm offset" + (12 -
                                (alignment === "left" ? 12 : tabGridCol)) /
                                2 + (bgType === "gradient" &&
                                (initializedA ? fullWidthTab : _this.fullWidthTab)
                                ? " " + styles.tabsBgOpacity
                                : "") + ((initializedA
                                ? fullWidthTab
                                : _this.fullWidthTab)
                                ? " " + styles.tabsPadMarAdjustA
                                : "") + " " + styles.tabsPadMarAdjustB + " " + styles.tabsGrid + (bottomClassName ? " " + bottomClassName : "") },
                            React.createElement("div", { className: (isTransparent
                                    ? ""
                                    : bgType === "light" &&
                                        !(initializedA ? fullWidthTab : _this.fullWidthTab)
                                        ? "bg-ui-white "
                                        : bgType === "dark" &&
                                            !(initializedA ? fullWidthTab : _this.fullWidthTab)
                                            ? "bg-black "
                                            : bgType === "grey" &&
                                                !(initializedA ? fullWidthTab : _this.fullWidthTab)
                                                ? "bg-ui-background-gray "
                                                : "") + "flex justify-center " + (bgType === "gradient" &&
                                    !(initializedA ? fullWidthTab : _this.fullWidthTab)
                                    ? styles.tabsBgOpacity + " "
                                    : "") + ((initializedA
                                    ? fullWidthTab
                                    : _this.fullWidthTab)
                                    ? styles.tabsNoBorderRadiusA + " "
                                    : "") + styles.tabsNoBorderRadiusB + " " + styles.tabsRow, ref: function (ref) { return (_this.tabsContRef = ref || undefined); }, style: isTransparent ? { backgroundColor: "transparent" } : {} },
                                React.createElement("div", { "aria-owns": ariaOwns, className: "flex flex-items-center overflow-x-auto overflow-y-hidden rel scrollbar-hidden " + styles.tabsRowInner + ((initializedA ? fullWidthTab : _this.fullWidthTab) ||
                                        (alignment === "left" && isTransparent)
                                        ? " " + styles.tabsRowInnerPadA
                                        : "") + (alignment === "left"
                                        ? " " + styles.tabsRowInnerLeft + (!isTransparent &&
                                            !(initializedA ? fullWidthTab : _this.fullWidthTab)
                                            ? " " + styles.tabsRowInnerPadB
                                            : "")
                                        : ""), id: "tab_scroll_" + name, ref: function (ref) { return (_this.tabsScrollRef = ref || undefined); }, role: "tablist" },
                                    data.map(function (item, index) {
                                        var btnWrapperFunction = item.btnWrapperFunction, id = item.id, tabName = item.tabName;
                                        var isActive = (initializedA ? currentIndex : _this.currentIndex) ===
                                            index;
                                        var isFirst = index === 0;
                                        var isLast = index === data.length - 1;
                                        var tabProps = {
                                            "aria-controls": name + "-tab-" + index,
                                            "aria-posinset": index + 1,
                                            "aria-selected": isActive,
                                            "aria-setsize": data.length,
                                            className: (isActive
                                                ? bgType === "dark"
                                                    ? "color-ui-dark-gray"
                                                    : "color-ui-white"
                                                : bgType === "dark"
                                                    ? "color-ui-white"
                                                    : "color-ui-dark-gray") + " font-medium line-h-base mar-b-none rel " + styles.tabsTab + (isActive
                                                ? ""
                                                : bgType === "light" || bgType === "grey"
                                                    ? " " + styles.tabsTabHoverBlue
                                                    : " " + styles.tabsTabHoverUnderline) + (isFirst ? " " + styles.tabsTabInitialMar : "") + " " + styles.tabsTabLeftMar + (isLast ? " " + styles.tabsTabLastMar : "") + (transitionOn ? " " + styles.tabsTabTransition : "") + "\n                                          " + (hideFocus
                                                ? " " + styles.tabsTabHideFocus
                                                : (isActive && bgType !== "dark") ||
                                                    (!isActive && bgType === "dark")
                                                    ? " " + styles.tabsTabWhiteFocus
                                                    : " " + styles.tabsTabUiBlackFocus) + " text-center type-base",
                                            id: name + "-" + index,
                                            index: index,
                                            key: id,
                                            onClick: _this.onMouseDown,
                                            onKeyUp: _this.onKeyUp,
                                            onMouseDown: _this.onMouseDown,
                                            role: "tab",
                                            style: isLast
                                                ? {}
                                                : {
                                                    marginRight: initializedA
                                                        ? tabMarR
                                                        : _this.tabMarR,
                                                },
                                            tabIndex: isActive ? 0 : -1,
                                        };
                                        return btnWrapperFunction ? (btnWrapperFunction(React.createElement("a", __assign({}, tabProps, { ref: function (ref) {
                                                return ref && (_this.tabsRef[index] = ref);
                                            } }), tabName))) : (React.createElement("button", __assign({}, tabProps, { ref: function (ref) {
                                                return ref && (_this.tabsRef[index] = ref);
                                            } }), tabName));
                                    }),
                                    (initializedA ? fullWidthTab : _this.fullWidthTab) && (React.createElement("div", { className: "tabs-tab-button-space" })),
                                    React.createElement("div", { className: "absolute flex flex-items-start height-full" + (transitionOn ? " " + styles.tabsBlackTabTransition : "") + " " + styles.tabsBlackTabOuter, style: {
                                            left: initializedA
                                                ? blackTabStyle.left
                                                : _this.blackTabStyleLeft,
                                            width: parseFloat((initializedA
                                                ? blackTabStyle.width
                                                : _this.blackTabStyleWidth).substring(0, (initializedA
                                                ? blackTabStyle.width
                                                : _this.blackTabStyleWidth).length - 2)) + 32 + "px",
                                        } },
                                        React.createElement("div", { className: (bgType === "dark" ? "bg-ui-white" : "bg-ui-black") + " " + styles.tabsBlackTab + (transitionOn
                                                ? " " + styles.tabsBlackTabTransition
                                                : ""), style: {
                                                width: initializedA
                                                    ? blackTabStyle.width
                                                    : _this.blackTabStyleWidth,
                                            } }))))))),
                React.createElement("div", { className: "rel flex " + (contentClassName ? " " + contentClassName : ""), style: { 'overflow': 'auto' } }, data.map(function (item, index) {
                    var component = item.component, id = item.id;
                    var slideDirClass = "";
                    if ((initializedA ? currentIndex : _this.currentIndex) !==
                        (initializedA ? prevIndex : _this.prevIndex)) {
                        if (index === (initializedA ? currentIndex : _this.currentIndex)) {
                            if ((initializedA ? currentIndex : _this.currentIndex) >
                                (initializedA ? prevIndex : _this.prevIndex)) {
                                slideDirClass = " " + styles.tabsContentSlideInRight;
                            }
                            else {
                                slideDirClass = " " + styles.tabsContentSlideInLeft;
                            }
                        }
                        else if (index === (initializedA ? prevIndex : _this.prevIndex)) {
                            if ((initializedA ? prevIndex : _this.prevIndex) >
                                (initializedA ? currentIndex : _this.currentIndex)) {
                                slideDirClass = " " + styles.tabsContentSlideOutLeft;
                            }
                            else {
                                slideDirClass = " " + styles.tabsContentSlideOutRight;
                            }
                        }
                    }
                    return (React.createElement("div", { "aria-labelledby": name + "-" + index, className: (index !== (initializedA ? currentIndex : _this.currentIndex) &&
                            index !== (initializedA ? prevIndex : _this.prevIndex)
                            ? "hide "
                            : "") + "rel " + styles.tabsContent + " " + (initializedB
                            ? styles.tabsContentDefaultAnimation
                            : styles.tabsContentDefaultAnimationOff) + slideDirClass, id: name + "-tab-" + index, key: id, role: "tabpanel", style: { top: 0, width: "100%" }, tabIndex: tabIndex ? tabIndex : 0 }, component));
                }))));
        };
        _this.state = {
            // style of black button overlay
            blackTabStyle: {
                left: "0px",
                width: "0px",
            },
            // current shown index
            currentIndex: 0,
            // determines if container is full-bleed
            fullWidthTab: false,
            // used to determine if focus is hidden
            hideFocus: false,
            // used to determine if component is initialized
            initializedA: false,
            // used to determine if component is initialized
            initializedB: false,
            // previous shown index
            prevIndex: 0,
            // variable padding between tab items
            tabMarR: "0px",
            // used to turn transition off for hover effects
            transitionOn: false,
            // sets if component is visible
            visible: false,
        };
        _this.blackTabStyleLeft = "0px";
        _this.blackTabStyleWidth = "0px";
        _this.currentIndex = 0;
        _this.fullWidthTab = false;
        _this.onClickTimeout = 0;
        _this.prevIndex = 0;
        _this.resizeTimeout = 0;
        _this.tabMarR = "0px";
        _this.tabsRef = [];
        _this.mounted = false;
        return _this;
    }
    return TabsContainer;
}(React.Component));
exports.default = TabsContainer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/TabsContainer/TabsContainer.js
// module id = 1853
// module chunks = 8